import type { Transition } from 'framer-motion';

/**
 * Movimento do palco (DESIGN.md §9). As durações espelham os tokens `--mv-*`
 * de `styles/tokens.css`; a saída é sempre mais curta que a entrada.
 */
export const MOVE = {
  tap: 0.1,
  card: 0.25,
  panel: 0.32,
  page: 0.34,
  character: 0.45,
} as const;

export const EASE_OUT = [0.32, 0.72, 0, 1] as const;

/** Painel que sobe do rodapé: mola firme, sem quicar. */
export const SPRING_PANEL: Transition = { type: 'spring', stiffness: 420, damping: 40, mass: 0.9 };

/** Cartão: um pouco mais vivo que o painel. */
export const SPRING_CARD: Transition = { type: 'spring', stiffness: 520, damping: 34, mass: 0.7 };

/** Saída: 70% do tempo da entrada, sem mola. */
export function exitIn(seconds: number): Transition {
  return { duration: seconds * 0.7, ease: EASE_OUT };
}

/** Com movimento reduzido no sistema, tudo vira troca seca. */
export const INSTANT: Transition = { duration: 0 };
